import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import DietPlanEditor from '@/components/diet/DietPlanEditor';

const STATUS_LABEL = {
  consultation_booked: 'Consultation Booked',
  preparing: 'Preparing',
  ready: 'Ready',
  completed: 'Completed',
};

const STATUS_COLOR = {
  consultation_booked: 'bg-slate-100 text-slate-700 border-slate-200',
  preparing: 'bg-amber-50 text-amber-800 border-amber-200',
  ready: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  completed: 'bg-sans_bone text-sans_ink border-sans_line',
};

const AdminDietPlans = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const load = () => {
    setLoading(true);
    api.get('/diet/appointments')
      .then(({ data }) => setItems(data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (selected) {
    return (
      <div>
        <button
          onClick={() => { setSelected(null); load(); }}
          className="sans-label hover:text-sans_ink"
          data-testid="diet-back-btn"
        >
          ← Back to all diet consultations
        </button>
        <div className="mt-6">
          <DietPlanEditor
            appointmentId={selected}
            onDelivered={() => { setSelected(null); load(); }}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Diet Planning</h1>
      <p className="text-sans_mute mt-2">Every ₹2,900 diet consultation. Prepare and deliver personalised plans.</p>

      <div className="mt-8 bg-white border border-sans_line overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-sans_line">
              {['Patient', 'Consultation slot', 'Reason', 'Status', 'Last update', ''].map((h) => (
                <th key={h} className="text-left px-4 py-3 font-medium text-[11px] tracking-[0.18em] uppercase text-sans_mute">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} className="px-4 py-8 text-center text-sans_mute">Loading…</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-sans_mute">No diet consultations yet.</td></tr>
            )}
            {items.map((a) => (
              <tr key={a.appointment_id} className="border-b border-sans_line hover:bg-sans_bone/50">
                <td className="px-4 py-3 text-sans_ink">
                  {a.user_name}
                  <div className="text-xs text-sans_mute">{a.user_email}</div>
                </td>
                <td className="px-4 py-3 text-sans_mute">
                  {new Date(a.slot_datetime).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}
                </td>
                <td className="px-4 py-3 text-sans_mute max-w-xs truncate">{a.reason || '—'}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] uppercase tracking-[0.2em] border px-2.5 py-1 ${STATUS_COLOR[a.plan_status] || STATUS_COLOR.consultation_booked}`}>
                    {STATUS_LABEL[a.plan_status] || 'Consultation Booked'}
                  </span>
                </td>
                <td className="px-4 py-3 text-sans_mute text-xs">
                  {a.plan_updated_at ? new Date(a.plan_updated_at).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—'}
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => setSelected(a.appointment_id)}
                    data-testid={`open-diet-${a.appointment_id}`}
                    className="text-xs text-sans_ink border border-sans_line px-3 py-1.5 hover:bg-sans_ink hover:text-sans_bone transition-colors"
                  >
                    Open plan
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDietPlans;
